import React from 'react'
import { useTranslation } from 'react-i18next';
import InstalBack from '../../../../assets/images/InstalBack.png'
import Instalingimg from '../../../../assets/images/Instalingimg.png'
import './Instalation.css'
function Installing() {
  const {t} = useTranslation();
  return (
    <div className='instal-main'>
     <div className='instalingimgtext'>
        <div className='instalingtext'>
        <h2>{t('At')} <span>{t('CE enologica,')} </span> {t('we prioritize client satisfaction.')}</h2>
          <p> {t('When you purchase equipment from us for your winery, our dedicated technical expert will personally visit your location for installation Our specialists will not only ensure your new product is perfectly set up, but wil also provide a comprehensive demonstration and training session to ensure you are fully equipped to make the most out of your new investment. We re here to support every step of your journey with expertise and care.')}</p>
        </div>
        <div className='longimg'>       
          <img src={Instalingimg} />
          </div>

         </div>

    </div>
  )
}

export default Installing;